module.exports = __webpack_public_path__ + "static/media/ssl-seal.f585c5d7.png";